import { video_schema } from './videoSchema'
import { isVideo } from './videoSchema'
import { pauseAllVideo } from './video'
import queryString from 'query-string';
import { error_event } from './analysis'
import { login } from './login';


function cashierLinkAddProductlevel(link) {
  //如果是收银台,增加product_level参数
  try {
    if (/https?:\/\/club\.mgtv\.com\/act\/mgtv_cashier_v2\.html.*/.test(link)) {
      const t = link.split('?');
      let params = {}
      if (t.length > 1) {
        params = queryString.parse(t[1]);
      }
      params['product_level'] = window.gact.is_ott ? 2 : 1;
      params['source'] = window.gact.source
      link = t[0] + '?' + queryString.stringify(params);
    }
    return link
  } catch (e) {
    error_event(e)
    return link
  }

}

/**
 *
 * @param {*} link
 * @returns
 */
function filterXWebParams(link) {
  if(/^https?.*/.test(link)) {
    const t = link.split('?');
    let params = {}
    if (t.length > 1 && (link.indexOf('use-xweb') !== -1 || link.indexOf('appid') !== -1)) {
      console.log('filterXWebParams', link)
      params = queryString.parse(t[1]);
      delete params['appid']
      delete params['use-xweb']
      return t[0] + '?' + queryString.stringify(params);
    } else {
      return link
    }
  } else {
    return link
  }
}

export function openLink(link) {
  if (!link) {
    return;
  }

  // 暂时不过滤，代码中暂未发现拼接频道页面自身 querystring 到跳转地址的
  // link = filterXWebParams(link)
  // console.log('openLink', link)

  //增加协议号
  if (/^\/\//.test(link)) {
    link = "https:" + link;
  } else if (link.indexOf(':') === -1 && link.indexOf('javascript;') === -1) {
    link = "https://" + link;
  }

  if (gact.debug) {
    window.location.href = link;
    return;
  }


  // console.log(isVideo(link))
  pauseAllVideo(); //跳链之前先暂停视频，为了MgtvApi.jumpPage或者schema打开后，视频仍然在播放的问题

  if (isVideo(link)) { //M站视频链接
    let schema = link;
    if (gact.is_app) {
      if (gact.is_ipad) {
        schema = video_schema(link, 'pad')
      } else {
        schema = video_schema(link, 'mobile')
      }
      openSchema(schema)
    } else {
      window.location.href = link;
    }
  } else if (/^imgotv/.test(link)) { //schecma
    openSchema(link)
  } else if (/^javascript;/.test(link)) { // javascript
    const t = /^javascript;(.*)$/.exec(link);
    if (t.length === 2) {
      eval(t[1]);
    }
  }
  else {

    //跳转
    if (gact.is_app) {
      if (gact.is_ios_app) {
        if (link.indexOf('%') >= 0) { //IOS APP BUG, 会对含有#的链接再次做encode
          window.location.href = link
        } else {
          MgtvApi.jumpPage({
            url: link
          });
        }
      } else {
        MgtvApi.jumpPage({
          url: link
        });
      }

    } else {
      window.location.href = link;

    }
  }
}


export function openSchema(schema) {
  if (!schema) {
    return;
  }
  if (window.gact.is_app) {
    window.location.href = schema
  } else {
    window.location.href = `https://a.app.qq.com/o/simple.jsp?pkgname=com.hunantv.imgo.activity&ios_scheme=${encodeURIComponent(schema)}&android_schema=${encodeURIComponent(schema)}&ckey=CK1393171797859`;
  }

}
